/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PopUpModal from '../../Common/PopUpModal/Modal.view';
import { isEmpty } from '../../../shared/utility/isEmpty';
import DynamicSVGIcon from '../../Common/DynamicSVGIcon';
import { filterIcon } from '../../../assets/icons';
import { getStringLocale } from '../../../constants/language';
import {
  FilterText,
  HeadingText,
  FilterLeftContainer,
  FilterBody,
  FilterIndividualText,
  FilterRightContainer,
  SubOptionText,
  FooterContainer
} from './WOFilters.styles';
import Radiobutton from '../../Common/RadioButton/RadioButton';
import { FlexContainer } from '../../../globalStyles';
import { useActions } from '../../../store/hooks/useActions';
import ButtonComp from '../../Common/Button/Button.view';
import { Input } from '../../Common/Input/Input';

const WOFilter = ({
  onCancel,
  filters: initialFilters,
  workOrders,
  handlePageChange,
  setSearchQueries
}) => {
  const { filtered: filters, searchable } = initialFilters;

  const [clickedOption, setClickedOption] = useState({});
  const [currentClicked, setCurrentClicked] = useState(
    filters[0] || searchable[0]
  );

  const { setSelectedFilters } = useActions();

  const { selectedFilters } = useSelector((state) => state.upsertWorkOrder);

  useEffect(() => {
    const key = filters[0]?.key;
    const availableOptions = filters[0]?.options?.map((item) => item?.label);
    if (!isEmpty(selectedFilters)) {
      setClickedOption({ ...selectedFilters });
    } else {
      setClickedOption({
        ...clickedOption,
        [filters[0]?.key]: {
          all: [...new Set(availableOptions)],
          selected: clickedOption[filters[0]?.key]?.selected || {}
        }
      });
    }
  }, [selectedFilters]);

  const [showInputBox, setShowInputBox] = useState(false);

  return (
    <PopUpModal
      width='94vw'
      style={{ padding: '0', height: '85vh' }}
      closeModalHandler={() => {}}
    >
      <div>
        <HeadingText>
          <FlexContainer className='ai_center' style={{ gap: '1rem' }}>
            <DynamicSVGIcon iconUrl={filterIcon} width='1.5rem' />
            <FilterText>{getStringLocale('Filter', 'en')}</FilterText>
          </FlexContainer>
          <ButtonComp
            dark
            onClick={() => {
              setCurrentClicked(filters[0] || searchable[0]);
              setSelectedFilters({});
              setSearchQueries({});
              if (filters[0]) {
                setShowInputBox(false);
                const availableOptions = filters[0]?.options?.map(
                  (item) => item?.label
                );
                setClickedOption({});
                // setClickedOption({
                //   ...clickedOption,
                //   [filters[0]?.key]: {
                //     all: [...new Set(availableOptions)],
                //     selected: clickedOption[filters[0]?.key]?.selected || {}
                //   }
                // });
              } else {
                setClickedOption({});
              }
            }}
          >
            {getStringLocale('Clear', 'en')}
          </ButtonComp>
        </HeadingText>
      </div>
      <FilterBody>
        <FilterLeftContainer>
          {filters?.map((filter) => (
            <FilterIndividualText
              className={
                filter?.key === currentClicked?.key ? 'highLighted' : ''
              }
              onClick={() => {
                setCurrentClicked(filter);
                if (!isEmpty(filter?.options)) {
                  const key = filter?.key;
                  const availableOptions = filter?.options?.map(
                    (item) => item?.label
                  );
                  setShowInputBox(false);
                  setClickedOption({
                    ...clickedOption,
                    [filter?.key]: {
                      all: [...new Set(availableOptions)],
                      selected: clickedOption[filter?.key]?.selected || {}
                    }
                  });
                }
              }}
            >
              {getStringLocale(filter?.title)}
            </FilterIndividualText>
          ))}
          {searchable?.map((search) => (
            <FilterIndividualText
              className={
                search?.key === currentClicked?.key ? 'highLighted' : ''
              }
              onClick={() => {
                setCurrentClicked(search);
                setShowInputBox(true);
              }}
            >
              {getStringLocale(search?.title)}
            </FilterIndividualText>
          ))}
        </FilterLeftContainer>
        <FilterRightContainer>
          {!showInputBox ? (
            <div>
              {clickedOption[currentClicked?.key]?.all?.map((sub) => (
                <FlexContainer
                  style={{ margin: '1rem 0 0 0' }}
                  className='ai_center'
                  onClick={() => {
                    setClickedOption({
                      ...clickedOption,
                      [currentClicked?.key]: {
                        ...clickedOption[currentClicked?.key],
                        selected: sub
                      }
                    });
                  }}
                >
                  <Radiobutton
                    onClick={() => {
                      setClickedOption({
                        ...clickedOption,
                        [currentClicked?.key]: {
                          ...clickedOption[currentClicked?.key],
                          selected: sub
                        }
                      });
                    }}
                    active={
                      sub === clickedOption[currentClicked?.key]?.selected
                    }
                  />
                  <SubOptionText>{getStringLocale(sub)}</SubOptionText>
                </FlexContainer>
              ))}
            </div>
          ) : (
            <div>
              <Input
                value={
                  isEmpty(clickedOption[currentClicked?.key]?.selected)
                    ? ''
                    : clickedOption[currentClicked?.key]?.selected
                }
                placeholder={getStringLocale(`Search ${currentClicked?.title}`)}
                onChange={(e) => {
                  setClickedOption({
                    ...clickedOption,
                    [currentClicked?.key]: {
                      selected: e.target.value
                    }
                  });
                }}
              />
            </div>
          )}
        </FilterRightContainer>
      </FilterBody>

      <FooterContainer>
        <FlexContainer className='ai_center jc_center' style={{ gap: '2rem' }}>
          <ButtonComp
            onClick={() => {
              onCancel();
            }}
          >
            {getStringLocale('Back', 'en')}
          </ButtonComp>
          <ButtonComp
            dark
            onClick={async () => {
              let searchFilters = {};

              await Object.keys(clickedOption)?.map((option) => {
                searchFilters = {
                  ...searchFilters,
                  [option]: !isEmpty(clickedOption[option]?.selected)
                    ? clickedOption[option]?.selected
                    : undefined
                };
              });
              const payload = {
                searchParams: {
                  ...searchFilters
                }
              };
              setSearchQueries(payload?.searchParams);
              setSelectedFilters({ ...clickedOption });
              handlePageChange(1, payload);

              onCancel();
            }}
          >
            {getStringLocale('Apply', 'en')}
          </ButtonComp>
        </FlexContainer>
      </FooterContainer>
    </PopUpModal>
  );
};

export default WOFilter;
